import OnboardingPensionContainer from '../containers/OnboardingPension/OnboardingPension.container'

const Home = () => {
  return (
    <OnboardingPensionContainer />
  )
}

export default Home
